"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _epics = _interopRequireDefault(require("./epics"));

var _reducers = _interopRequireDefault(require("./reducers"));

var _AsyncEcommerceSettingsContainer = _interopRequireDefault(require("./multistore/components/AsyncEcommerceSettingsContainer"));

var route = 'ecommerce';
var _default = {
  reducer: _reducers.default,
  routes: _react.default.createElement(_reactRouter.Route, {
    path: route,
    component: _AsyncEcommerceSettingsContainer.default
  }),
  route: route,
  rootEpic: _epics.default,
  shouldModuleRender: function shouldModuleRender(_ref) {
    var gates = _ref.gates;
    return gates.includes('settings-ui-beta:ecommerce') && gates.includes('Integrations:Shopify');
  }
};
exports.default = _default;
module.exports = exports.default;